import RadioButton from './RadioButton';
import { RadioButtonGroupProps } from './RadioButtonGroup.types';

function RadioButtonGroup({
  title,
  name,
  options,
  selectedValue,
  onChange,
  direction = 'vertical'
}: RadioButtonGroupProps) {
  return (
    <div className="flex flex-col gap-2">
      {title && (
        <div className="text-gray-800 text-left font-inter font-medium text-sm leading-5">
          {title}
        </div>
      )}
      <div
        className={`flex ${
          direction === 'horizontal' ? 'flex-row' : 'flex-col'
        } gap-2`}
      >
        {options.map((option) => (
          <RadioButton
            key={option.value}
            label={option.label}
            value={option.value}
            name={name}
            checked={selectedValue === option.value}
            onChange={onChange}
          />
        ))}
      </div>
    </div>
  );
}

export default RadioButtonGroup;
